import { useMemo } from "react";
import PageContainer from "../components/PageContainer";
import WideTile from "../components/WideTile";
import ProcessedItem from "../interfaces/ProcessedItem";
import Styled from "styled-components";

const TileHeader = Styled.div`
	background: linear-gradient(135deg, rgba(0, 137, 150, 0.1), rgba(0, 137, 150, 0.05));
    border-left: 5px solid rgba(0, 137, 150, 0.4);

	margin: 10px;
	padding: 10px;
	font-size: 20pt;

	.main {
		color: orange;
		font-weight: bold;
	}
	.subtitle {
		font-size: 15pt;
	}
`;

interface Props {
	item: ProcessedItem,
}

export default function ItemScreen(props: Props) {

	const enabledItems = useMemo(() => {
		if (!props.item.items) {
			return [];
		}

		return props.item.items.filter(i => !i.disabled).sort((a, b) => {
			return a.name.localeCompare(b.name);
		})
	}, [ props.item.items ]);

	const disabledItems = useMemo(() => {
		if (!props.item.items) {
			return [];
		}

		return props.item.items.filter(i => i.disabled).sort((a, b) => {
			return a.name.localeCompare(b.name);
		})
	}, [ props.item.items ]);

	return (
		<PageContainer>
			<TileHeader style={{
				padding: "10px",
				backgroundColor: "rgba(0, 0, 0, .25)",
				borderRadius: "5px",
			}}>
				<div className="main">{props.item.name}</div>
				<div className="subtitle">{props.item.description}</div>
			</TileHeader>
			{enabledItems.map((item, ind) => {
				let to = item.link || item.slug;
				return (
					<WideTile
						key={ind}
						to={to}
						icon={item.icon}
						title={item.name}
						description={item.description}
						disabled={item.disabled}
						target={item.target}
						exact={item.exact}
					/>
				);
			})}
			{disabledItems.map((item, ind) => {
				let to = item.link || item.slug;
				return (
					<WideTile
						key={ind}
						to={to}
						icon={item.icon}
						title={item.name}
						description={item.description}
						disabled={item.disabled}
						target={item.target}
						exact={item.exact}
					/>
				);
			})}
		</PageContainer>
	);
}